import {
  ADMIN_LOGIN_URL,
  GET_ALL_USER_DATA,
  UPDATE_USER_PROFILE,
  CHANGE_PASSWORD,
  FORGOT_PASSWORD,
  GET_USER_DETAILS,
  UPDATE_PROFILE_PIC,
  RESET_PASSWORD,
  DELETE_USER_DETAILS,
  GET_ALL_POSTS,
  CREATE_POST,
  DELETE_POST,
  GET_FLAGGED_POSTS,
  APPROVE_POST,
  BLOCK_POST,
  GET_BLOCKED_USERS,
  BLOCK_USER,
  UNBLOCK_USER,
  GET_ADMIN_DASHBOARD_SUMMARY,
  GET_USERS_OVER_TIME,
  GET_REVENUE_OVER_TIME,
  GET_MOOD_TRENDS,
  GET_JOURNAL_ENTRIES_OVER_TIME,
  GET_COMMUNITY_POSTS_OVER_TIME,
  // Subscription endpoints
  GET_SUBSCRIPTION_HISTORY,
  GET_ONGOING_SUBSCRIPTION,
  GET_DROPDOWN,
  UPDATE_DROPDOWN,
  // Newsletter endpoints
  GET_NEWSLETTER_SUBSCRIBERS,
  UNSUBSCRIBE_NEWSLETTER
} from "../api/api";
import axios from "axios";
import { LOADER, LOG_OUT, REQUEST_LOGIN_SUCCESS } from "../utils/constants";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { publicRequest, userRequest } from "./http.service";


export const adminLogin = (data1, callback) => async (dispatch) => {
  try {
    dispatch({ type: LOADER, payload: true });
    const response = await publicRequest.post(ADMIN_LOGIN_URL, data1);
    if (response.data.code === 200) {
      localStorage.setItem("token", response.data.data.token);
      dispatch({ type: REQUEST_LOGIN_SUCCESS, payload: response.data });
      dispatch({ type: LOADER, payload: false });
      callback(response.data);
      toast(response.data.message, { autoClose: 1000 });
    } else if (response.data.code !== 200) {
      toast.error(response.data.message, { autoClose: 1000 });
      callback(response.data);
    }
  } catch (error) {
    if (error) {
      toast.error("Something Went Wrong", { autoClose: 1000 });
      dispatch({ type: LOADER, payload: false });
    }
  } finally {
    dispatch({ type: LOADER, payload: false });
  }
};

export const getAllUsersData = (page = 1, search = "", callback, limit = 10, pagination = true) => async (dispatch) => {
  try {
    dispatch({ type: LOADER, payload: true });

    const response = await userRequest.get(
      `${GET_ALL_USER_DATA}?page=${page}&limit=${limit}&searchKey=${search}&pagination=${pagination}`);

    if (response.data.code === 200) {
      dispatch({ type: LOADER, payload: false });
      callback(response.data.data);
    } else if (response.data.code !== 200) {
      dispatch({ type: LOADER, payload: false });
      toast.error(response?.data.data.message, { autoClose: 1000 });
    }
  } catch (error) {
    dispatch({ type: LOADER, payload: false });
    console.error(error);
  }
};

export const updateUserProfileImage = (formData, token, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });

      const config = {
        headers: {
          "Content-Type": "multipart/form-data", // Change content type to multipart/form-data
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.put(
        `${UPDATE_PROFILE_PIC}`,
        formData,
        config
      );

      if (response.data.status === 200) {
        dispatch({ type: LOADER, payload: false });
        toast(response?.data?.message, { autoClose: 1000 });
        callback(response.data);
      } else if (response.data.status === 404) {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message, { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
    }
  };
};


export const updateProfile = (id, payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: LOADER, payload: true });

    try {
      const response = await userRequest.put(
        `${UPDATE_USER_PROFILE}`,
        payload
      );

      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        toast(response.data.message, { autoClose: 1000 });
        callback(response.data);
      } else {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message, { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
    }
  };
};

export const changePassword = (payload, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });

      const response = await userRequest.post(
        `${CHANGE_PASSWORD}`, payload
      );

      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        toast(response?.data.message, { autoClose: 1000 });
        callback(response.data);
      } else if (response.data.code !== 201) {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data.message, { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      if (error.response && error.response.code === 401) { /* empty */ }
    }
  };
};

export const forgotPassword = (email, callback) => async (dispatch) => {
  try {
    dispatch({ type: LOADER, payload: true });

    const response = await publicRequest.post(FORGOT_PASSWORD, { email });

    if (response.data.code === 200) {
      callback(response.data); // optional result handling
      toast('Reset link sent!', { autoClose: 1000 });
    } else {
      toast(response.data.message || 'Failed to send reset link', { autoClose: 1000 });
    }
  } catch (error) {
    toast('Something went wrong!', { autoClose: 1000 });
  } finally {
    dispatch({ type: LOADER, payload: false });
  }
};
export const resetPassword = (token, newPassword, callback) => async (dispatch) => {
  try {
    dispatch({ type: LOADER, payload: true });
    const response = await publicRequest.post(RESET_PASSWORD, {
      token,
      newPassword
    });

    if (response.data.code === 200) {
      toast.success(response.data.message, { autoClose: 1500 });
      callback(response.data);
    } else {
      toast.error(response.data.message || 'Invalid or expired link');
    }
  } catch (error) {
    toast.error('Something went wrong');
  } finally {
    dispatch({ type: LOADER, payload: false });
  }
};

export const getUserProfileDetail = (payload, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });
      const response = await userRequest.get(
        `${GET_USER_DETAILS}/${payload.userId}`
      );
      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        dispatch({ type: REQUEST_LOGIN_SUCCESS, payload: response.data });
        callback(response.data.data);
      } else if (response.data.code !== 200) {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message, { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
    }
  };
};

export const logout = () => async (dispatch) => {
  localStorage.clear("token");
  dispatch({ type: LOG_OUT, data: false });
  toast.success("Logout successful");
  return true;
};

export const deleteUser = (payload, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });

      const response = await userRequest.delete(
        `${DELETE_USER_DETAILS}/${payload.userId}`
      );

      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        toast(response?.data.message, { autoClose: 1000 });
        callback(response.data);
      } else if (response.data.code === 404) {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data.message, { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      if (error.response && error.response.code === 401) { /* empty */ }
    }
  };
};

export const getAllPosts = (page = 1, limit = 10, search = "",  topicTag = "", phaseTag = "", callback) => async (dispatch) => {
  try {
    dispatch({ type: LOADER, payload: true });

    const response = await userRequest.get(
      `${GET_ALL_POSTS}?page=${page}&limit=${limit}&search=${search}&topicTag=${topicTag}&phaseTag=${phaseTag}`
    );

    if (response.data.code === 200) {
      dispatch({ type: LOADER, payload: false });
      callback(response.data.data);
    } else if (response.data.code !== 200) {
      dispatch({ type: LOADER, payload: false });
      toast.error(response?.data?.message, { autoClose: 1000 });
    }
  } catch (error) {
    dispatch({ type: LOADER, payload: false });
    console.error(error);
    toast.error("Failed to fetch posts", { autoClose: 1000 });
  }
};

export const createNewPost = (formData, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });

      const config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };

      const response = await userRequest.post(CREATE_POST, formData, config);

      if (response.data.code === 201 || response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        toast.success(response?.data?.message, { autoClose: 1000 });
        callback(response.data);
      } else {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message, { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      console.error(error);
      toast.error("Failed to create post", { autoClose: 1000 });
    }
  };
};

export const deletePostById = (postId, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });

      const response = await userRequest.delete(`${DELETE_POST}/${postId}`);

      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        toast.success(response?.data?.message, { autoClose: 1000 });
        callback(response.data);
      } else if (response.data.code === 404) {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message, { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      console.error(error);
      toast.error("Failed to delete post", { autoClose: 1000 });
    }
  };
};

export const getSingleUserData = (userId, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });

      const response = await userRequest.get(
        `${GET_USER_DETAILS}/${userId}`
      );

      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        callback(response.data.data);
      } else if (response.data.code !== 200) {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message, { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      console.error(error);
      toast.error("Failed to fetch user details", { autoClose: 1000 });
    }
  };
};

export const getFlaggedPosts = (page = 1, limit = 10, search = "", callback) => async (dispatch) => {
  try {
    dispatch({ type: LOADER, payload: true });

    const response = await userRequest.get(
      `${GET_FLAGGED_POSTS}?page=${page}&limit=${limit}&search=${search}`
    );

    if (response.data.code === 200) {
      dispatch({ type: LOADER, payload: false });
      callback(response.data.data);
    } else if (response.data.code !== 200) {
      dispatch({ type: LOADER, payload: false });
      toast.error(response?.data?.message, { autoClose: 1000 });
    }
  } catch (error) {
    dispatch({ type: LOADER, payload: false });
    console.error(error);
    toast.error("Failed to fetch flagged posts", { autoClose: 1000 });
  }
};

export const approveFlaggedPost = (postId, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });

      const response = await userRequest.put(
        `${APPROVE_POST}/${postId}/approve`
      );

      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        toast.success("Post approved successfully", { autoClose: 1000 });
        callback(response.data.data);
      } else {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message, { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      console.error(error);
      toast.error("Failed to approve post", { autoClose: 1000 });
    }
  };
};

export const blockFlaggedPost = (postId, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });

      const response = await userRequest.put(
        `${BLOCK_POST}/${postId}/block`
      );

      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        toast.success("Post blocked successfully", { autoClose: 1000 });
        callback(response.data.data);
      } else {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message, { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      console.error(error);
      toast.error("Failed to block post", { autoClose: 1000 });
    }
  };
};

export const getBlockedUsers = (page = 1, limit = 10, search = "", callback, pagination = true) => async (dispatch) => {
  try {
    dispatch({ type: LOADER, payload: true });

    const response = await userRequest.get(
      `${GET_BLOCKED_USERS}?page=${page}&limit=${limit}&searchKey=${search}&pagination=${pagination}`
    );

    if (response.data.code === 200) {
      dispatch({ type: LOADER, payload: false });
      callback(response.data.data);
    } else if (response.data.code !== 200) {
      dispatch({ type: LOADER, payload: false });
      toast.error(response?.data?.message, { autoClose: 1000 });
    }
  } catch (error) {
    dispatch({ type: LOADER, payload: false });
    console.error(error);
    toast.error("Failed to fetch blocked users", { autoClose: 1000 });
  }
};

export const blockUser = (userId, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });

      const response = await userRequest.put(
        `${BLOCK_USER}/${userId}/block`
      );

      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        toast.success("User blocked successfully", { autoClose: 1000 });
        callback(response.data.data);
      } else {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message, { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      console.error(error);
      toast.error("Failed to block user", { autoClose: 1000 });
    }
  };
};

export const unblockUser = (userId, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });

      const response = await userRequest.put(
        `${UNBLOCK_USER}/${userId}/unblock`
      );

      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        toast.success("User unblocked successfully", { autoClose: 1000 });
        callback(response.data.data);
      } else {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message, { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      console.error(error);
      toast.error("Failed to unblock user", { autoClose: 1000 });
    }
  };
};

export const getAdminDashboardSummary = (callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });

      const response = await userRequest.get(
        `${GET_ADMIN_DASHBOARD_SUMMARY}`
      );

      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        callback(response.data.data);
      } else if (response.data.code !== 200) {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message, { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      console.error(error);
      toast.error("Failed to fetch dashboard summary", { autoClose: 1000 });
    }
  };
};

/**
 * Admin analytics: users over time
 */
export const getUsersOverTime = (range = 30, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });
      const response = await userRequest.get(`${GET_USERS_OVER_TIME}?range=${range}`);
      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        callback(response.data.data);
      } else {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message || "Failed to fetch users over time", { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      console.error("getUsersOverTime error:", error);
      toast.error("Failed to fetch users over time", { autoClose: 1000 });
    }
  };
};

/**
 * Admin analytics: revenue over time
 */
export const getRevenueOverTime = (range = 30, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });
      const response = await userRequest.get(`${GET_REVENUE_OVER_TIME}?range=${range}`);
      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        callback(response.data.data);
      } else {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message || "Failed to fetch revenue over time", { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      console.error("getRevenueOverTime error:", error);
      toast.error("Failed to fetch revenue over time", { autoClose: 1000 });
    }
  };
};


/**
 * Admin analytics: journal entries over time (client timezone aware)
 * Sends client's tzOffset (minutes) so server can aggregate into the client's day boundaries.
 */
export const getJournalEntriesOverTime = (range = 30, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });
      const tzOffset = new Date().getTimezoneOffset(); // minutes offset from UTC (e.g. -330 for IST)
      const response = await userRequest.get(`${GET_JOURNAL_ENTRIES_OVER_TIME}?range=${range}&tzOffset=${tzOffset}`);
      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        callback(response.data.data);
      } else {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message || "Failed to fetch journal entries over time", { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      console.error("getJournalEntriesOverTime error:", error);
      toast.error("Failed to fetch journal entries over time", { autoClose: 1000 });
    }
  };
};

/**
 * Admin analytics: community posts over time (client timezone aware)
 */
export const getCommunityPostsOverTime = (range = 30, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });
      const tzOffset = new Date().getTimezoneOffset();
      const response = await userRequest.get(`${GET_COMMUNITY_POSTS_OVER_TIME}?range=${range}&tzOffset=${tzOffset}`);
      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        callback(response.data.data);
      } else {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message || "Failed to fetch community posts over time", { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      console.error("getCommunityPostsOverTime error:", error);
      toast.error("Failed to fetch community posts over time", { autoClose: 1000 });
    }
  };
};


export const getAllDropdowns = (callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });

      const response = await userRequest.get(`${GET_DROPDOWN}`);

      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        callback(response.data);
      } else {
        dispatch({ type: LOADER, payload: false });
        toast.error(response.data.message, { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      toast.error("Failed to load dropdown options");
    }
  };
};

// ⭐ ADD OPTION
export const addDropdownOption = (category, label, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });

      const response = await userRequest.post(`${UPDATE_DROPDOWN}/add`, {
        category,
        label
      });

      if (response.data.code === 201) {
        dispatch({ type: LOADER, payload: false });
        toast.success(response.data.message, { autoClose: 1000 });

        callback(response.data.data);
      } else {
        dispatch({ type: LOADER, payload: false });
        toast.error(response.data.message, { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      toast.error("Failed to add option");
    }
  };
};

// ⭐ REMOVE OPTION
export const removeDropdownOption = (category, optionId, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });

      const response = await userRequest.delete(
        `${UPDATE_DROPDOWN}/remove/${category}/${optionId}`
      );

      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        toast.success(response.data.message, { autoClose: 1000 });
        callback(response.data.data);
      } else {
        dispatch({ type: LOADER, payload: false });
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      toast.error("Failed to delete option");
    }
  };
};

// Fetch subscription history (for admins can pass userId to fetch another user's history)
export const getSubscriptionHistory = (userId = null, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });
      const url = userId ? `${GET_SUBSCRIPTION_HISTORY}?userId=${userId}` : `${GET_SUBSCRIPTION_HISTORY}`;
      const response = await userRequest.get(url);
      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        callback(response.data.data);
      } else {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message || "Failed to fetch subscription history", { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      console.error("getSubscriptionHistory error:", error);
      toast.error("Failed to fetch subscription history", { autoClose: 1000 });
    }
  };
};

// Get newsletter subscribers
export const getNewsletterSubscribers = (page = 1, limit = 10, search = "", isSubscribed = "", callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });
      
      let url = `${GET_NEWSLETTER_SUBSCRIBERS}?page=${page}&limit=${limit}&searchKey=${search}`;
      if (isSubscribed !== "") {
        url += `&isSubscribed=${isSubscribed}`;
      }
      
      const response = await userRequest.get(url);
      
      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        callback(response.data.data);
      } else {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message || "Failed to fetch newsletter subscribers", { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      console.error("getNewsletterSubscribers error:", error);
      toast.error("Failed to fetch newsletter subscribers", { autoClose: 1000 });
    }
  };
};

// Admin unsubscribe newsletter subscriber
export const unsubscribeNewsletterSubscriber = (id, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOADER, payload: true });
      
      const response = await userRequest.put(`${UNSUBSCRIBE_NEWSLETTER}/${id}`);
      
      if (response.data.code === 200) {
        dispatch({ type: LOADER, payload: false });
        toast.success("Subscriber unsubscribed successfully", { autoClose: 1000 });
        callback(response.data);
      } else {
        dispatch({ type: LOADER, payload: false });
        toast.error(response?.data?.message || "Failed to unsubscribe subscriber", { autoClose: 1000 });
      }
    } catch (error) {
      dispatch({ type: LOADER, payload: false });
      console.error("unsubscribeNewsletterSubscriber error:", error);
      toast.error("Failed to unsubscribe subscriber", { autoClose: 1000 });
    }
  };
};
